module.exports = __webpack_public_path__ + "static/media/Dobro - map icons_Mlin Đakovo icon (1).62b537f8.svg";